import { Navigate, Route, Routes } from "react-router-dom";
import { ComposeProviders, entities, modules } from "byzantine";
import InvoiceContainer from "./InvoiceContainer";
import UploadStep from "./UploadStep";
import DetailsStep from "./DetailsStep";
import ReviewStep from "./ReviewStep";
import ReceiptStep from "./ReceiptStep";
import { InvoiceFlowProvider, useInvoiceFlow } from "./InvoiceFlowContext";
import { SudoProvider } from "../../SudoContext";
import RequestOTP from "../../SudoContext/RequestOTP";
import SubmitOTP from "../../SudoContext/SubmitOTP";
import { useInstitutionSettings } from "../../contexts/InstitutionSettingsContext";

// corresponding to routes in indigo/urls.py
export const INVOICE_ROUTE = "invoice";
export const INVOICE_DETAILS_ROUTE = "details";
export const INVOICE_REVIEW_ROUTE = "review";
export const INVOICE_RECEIPT_ROUTE = "receipt";

const Providers = [
  modules.achPayments.bootstrap.Provider,
  entities.recipients.RecipientProfileForm.Provider,
  entities.recipients.ACHDestinationForm.Provider,
  entities.recipients.ACHPaymentRecipientForm.Provider,
];

const RequireRecipientAndFile = ({
  children,
  redirectTo,
}: {
  children: React.ReactNode;
  redirectTo: string;
}) => {
  const { previewUrl } = useInvoiceFlow();
  const selectedRecipient = entities.recipients.useSelectedRecipient();

  if (!previewUrl || !selectedRecipient) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

const InvoiceRoutes = () => {
  const institution = useInstitutionSettings();
  const uploadRoute = `/transfer/${INVOICE_ROUTE}`;

  if (!Object.prototype.hasOwnProperty.call(institution, "ach_next_cutoff")) {
    return null;
  }

  return (
    <ComposeProviders components={Providers}>
      <modules.achPayments.ACHPaymentForm.Provider>
        <SudoProvider basename={`transfer/${INVOICE_ROUTE}`}>
          <InvoiceFlowProvider>
            <InvoiceContainer>
              <Routes>
                <Route index element={<UploadStep />} />
                <Route
                  path={INVOICE_DETAILS_ROUTE}
                  element={
                    <RequireRecipientAndFile redirectTo={uploadRoute}>
                      <DetailsStep />
                    </RequireRecipientAndFile>
                  }
                />
                <Route
                  path={INVOICE_REVIEW_ROUTE}
                  element={
                    <RequireRecipientAndFile redirectTo={uploadRoute}>
                      <ReviewStep />
                    </RequireRecipientAndFile>
                  }
                />
                <Route
                  path={`${INVOICE_RECEIPT_ROUTE}/:uuid?`}
                  element={
                    <RequireRecipientAndFile redirectTo={uploadRoute}>
                      <ReceiptStep />
                    </RequireRecipientAndFile>
                  }
                />
                <Route
                  path="sudo/request-otp"
                  element={
                    <RequireRecipientAndFile redirectTo={uploadRoute}>
                      <RequestOTP />
                    </RequireRecipientAndFile>
                  }
                />
                <Route
                  path="sudo/submit-otp"
                  element={
                    <RequireRecipientAndFile redirectTo={uploadRoute}>
                      <SubmitOTP />
                    </RequireRecipientAndFile>
                  }
                />
              </Routes>
            </InvoiceContainer>
          </InvoiceFlowProvider>
        </SudoProvider>
      </modules.achPayments.ACHPaymentForm.Provider>
    </ComposeProviders>
  );
};

export default InvoiceRoutes;
